import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

export const Moon01 = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
            <g id="moon-01">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.066 1.69326C10.3269 1.95412 10.423 2.33744 10.316 2.69051C10.0708 3.49941 9.93856 4.35859 9.93856 5.25044C9.93856 10.1162 13.883 14.0606 18.7487 14.0606C19.641 14.0606 20.5005 13.9283 21.3097 13.6829C21.6628 13.5758 22.0461 13.6718 22.307 13.9327C22.5679 14.1935 22.664 14.5769 22.5569 14.9299C21.2117 19.3678 17.0897 22.6 12.2102 22.6C6.2399 22.6 1.40002 17.7601 1.40002 11.7898C1.40002 6.91077 4.63156 2.7891 9.06875 1.44345C9.42181 1.33638 9.80514 1.43241 10.066 1.69326ZM8.00502 4.04578C5.26125 5.53893 3.40002 8.44794 3.40002 11.7898C3.40002 16.6555 7.34447 20.6 12.2102 20.6C15.5525 20.6 18.4618 18.7383 19.9547 15.994C19.5586 16.038 19.1562 16.0606 18.7487 16.0606C12.7784 16.0606 7.93856 11.2207 7.93856 5.25044C7.93856 4.84347 7.9611 4.4415 8.00502 4.04578Z"
                    className="fill-current"
                />
            </g>
        </SvgIcon>
    );
};
